// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LocalizedParagraph, type LocalizedText} from 'components/Localized';
import {BackgroundImage} from 'components/Image'
import {fadeIn} from './ButtonSpot';
import ImgLine from 'assets/images/driving-zone/b/img-line-media.svg';

type Props = {
  localText: LocalizedText,
};

export default function SpotMessage(props: Props): React.Element<any> {
  return (
    <GuidePointMessage>
      <div>
        <LocalizedParagraph {...props.localText} />
      </div>
    </GuidePointMessage>
  );
}

export function SpotGuideMessage(props: Props): React.Element<any> {
  return (
    <GuideLineMessage source="./driving-zone/line-gtmode-click-here.png">
      <div>
        <LocalizedParagraph {...props.localText} />
      </div>
    </GuideLineMessage>
  );
}

const GuidePointMessage = styled.div`
  background-image: url(${ImgLine});
  background-size: 138px 36px;
  background-position: left top;
  background-repeat: no-repeat;
  width: max-content;
  min-height: ${(props) => (props.theme.layout.mobile ? 36 : 54)}px;
  padding-top: ${(props) => (props.theme.layout.mobile ? 1 : 1)}px;
  position: absolute;
  top: ${(props) => (props.theme.layout.mobile ? -32 : -39)}px;
  left: ${(props) => (props.theme.layout.mobile ? 55 : 94)}px;
  animation: 5s ease-in-out 0s ${fadeIn};

  > div {
    margin-left: ${(props) => (props.theme.layout.mobile ? 70 : 87)}px;
    padding-right: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;
    padding-top: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;

    border-top: 1px solid #ffffff;

    p {
    text-align: left;
    }
  }
`;

const GuideLineMessage = styled(BackgroundImage)`
  position: absolute;
  top: ${(props) => (props.theme.layout.mobile ? -15 : -36)}px;
  left: ${(props) => (props.theme.layout.mobile ? 51 : 80)}px;
  
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: contain;
  width: ${(props) => (props.theme.layout.mobile ? 31 : 61)}px;
  height: ${(props) => (props.theme.layout.mobile ? 30 : 60)}px;
  
  animation: 5s ease-in-out 0s ${fadeIn};

  > div {
    margin-left: ${(props) => (props.theme.layout.mobile ? 70 : 87)}px;

    p {
      position: absolute;
      left: ${(props) => (props.theme.layout.mobile ? 35 : 69)}px;
      bottom: ${(props) => (props.theme.layout.mobile ? 31 : 62)}px;
      white-space: nowrap;
    }
  }
`;